module.exports = __webpack_public_path__ + "54525d78e7a6e8e13f4e9741e7197ff7.svg";